// extracted by mini-css-extract-plugin
module.exports = {"card_hover":"UnitsList_card_hover__11900","dashboard__card-widget":"UnitsList_dashboard__card-widget__3Yo0l","dashboard_icon":"UnitsList_dashboard_icon__1vA8J"};